module.exports = __webpack_public_path__ + "28c6716932aeee13d7f9b9603f5e2645.mp4";